import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
    fetchTiposServiciosProjecto,
    createTipoServicioProjecto,
    updateTipoServicioProjecto,
    deleteTipoServicioProjecto,
} from '../../api/administration/serviceTypeProjectApi';

export const useServicesTypesProject = () => {
    const queryClient = useQueryClient();

    const { data: servicesTypesProject, isLoading, error } = useQuery({
        queryKey: ['tipos-servicios-proyecto'],
        queryFn: fetchTiposServiciosProjecto,
    });

    const createMutation = useMutation({
        mutationFn: createTipoServicioProjecto,
        onSuccess: () => {
            queryClient.invalidateQueries(['tipos-servicios-proyecto']);
        },
    });

    const updateMutation = useMutation({
        mutationFn: ({ id, data }) => updateTipoServicioProjecto(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries(['tipos-servicios-proyecto']);
        },
    });

    const deleteMutation = useMutation({
        mutationFn: deleteTipoServicioProjecto,
        onSuccess: () => {
            queryClient.invalidateQueries(['tipos-servicios-proyecto']);
        },
    });

    return {
        servicesTypesProject,
        isLoading,
        error,
        createMutation,
        updateMutation,
        deleteMutation,
    };
};
